export default __webpack_public_path__ + "static/media/onevsone.a7bc9999.jpg";